import React from 'react';
import { Box, Container, Link, SvgIcon, Typography } from '@material-ui/core'

const Title = ({ children }) => (
  <Typography variant="h3" style={{ marginTop: "1em" }}>
    {children}
  </Typography>
)
const Paragraph = ({ children }) => (
  <Typography variant="body1" style={{ marginTop: "1em" }}>
    {children}
  </Typography>
)

const OutroText = ({ captureType }) => {
  switch (captureType) {
    case 'none':
      return (
        <Title>
          Děkujeme, tento výzkum se zabývá pouze lidmi, kteří nemoc prodělali, nebo ji aktuálně prodělávají.
        </Title>
      )
    case 'prospective':
      return (
        <>
          <Title>
            Vaše odpovědi byly úspěšně zaznamenány.
          </Title>
          <Paragraph>
            Děkujeme, na uvedený kontakt vás budeme v budoucnu kontaktovat s dotazníkem ohledně průběhu onemocnění.
            Vaše data jsou v bezpečí a budou použita výhradně pro průzkum dopadů onemocnění COVID-19.
          </Paragraph>
        </>
      )
    default:
      return (
        <>
          <Title>
            Vaše odpovědi byly úspěšně zaznamenány.
          </Title>
          <Paragraph>
            Děkujeme za vyplnění dotazníku. Vaše data jsou v bezpečí a budou použita výhradně pro průzkum
            dopadů onemocnění COVID-19.
          </Paragraph>
        </>
      )
  }
}

export const Outro = ({ captureType }) => {
  return (
    <Container maxWidth="md">
      <Box textAlign="center">
        <OutroText captureType={captureType}/>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: 'center', margin: "3em" }}>
          <Box sx={{ alignItems: 'center', display: 'flex' }}>
            <SvgIcon component="object" style={{ marginRight: "0.3em" }}>
              <embed type="image/svg+xml" src="/favicon.svg" width="24"/>
            </SvgIcon>
            <Typography variant="h3">
              <Link href="https://medevio.cz/" underline="hover" color="textPrimary">
                MEDEVIO
              </Link>
            </Typography>
          </Box>
        </Box>
      </Box>

    </Container>
  )
}
